<template>
  <div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <CCol sm="12">
                    <!-- Name -->
                    <CRow>
                        <CCol sm="12">
                            <CInput label="Nome*" placeholder="" v-model="place.name" :is-valid="nameValidator"/>
                        </CCol>
                    </CRow>
                    <!-- Notes -->
                    <CRow>
                        <CCol sm="3">
                            <label class="">Imagem</label>
                            <div title="Choose an image"
                                class="base-image-input"
                                :style="{ 'background-image': `url(${imageData})` }"
                                @click="chooseImage"
                                v-bind:class="{'is-invalid': genericValidator() == false}">
                                <span
                                v-if="!imageData"
                                class="placeholder"
                                >
                                Escolher imagem
                                </span>
                                <input
                                class="file-input"
                                ref="fileInput"
                                type="file"
                                @change="onSelectFile"
                                >
                            </div>
                        </CCol>
                        <CCol sm="9">
                            <CTextarea label="Notas" placeholder="" vertical v-model="place.notes" rows="12"  :is-valid="genericValidator()"/>
                        </CCol>
                    </CRow>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loading" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
                        </CRow>
                    </CCol>
                </CCol>
            </CCardBody>
        </CCard>
    </CCol>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Place from "@/classes/Place";
import InputPlace from "@/classes/InputPlace";
import { UTILS_HELPER } from "@/helpers/utils.js";

export default {
    props:{    
        basePlace:
        {
            type: Object,
            default: null
        }
    },
    data()
    {
        return {
            imageData: '', // The direct binding to place.path was not working correctly
            submitted: false,
            place: new Place(),
            loading: false
        }
    },
    mounted: function()
    {
        this.resetPlace();
    },
    computed:
    {
        ...mapState('alert', ['type']),
        ...mapState('alert', ['message'])
    },
    methods:{
        chooseImage () {
            this.$refs.fileInput.click();
        },   
        onSelectFile () {
            const input = this.$refs.fileInput;
            const files = input.files;
            if (files && files[0]) {
                const reader = new FileReader();
                reader.onload = e => {
                this.imageData = e.target.result;
                }
                reader.readAsDataURL(files[0]);
            }
        },
        resetPlace(){
            if(!this.basePlace)
            {
                this.place = new Place();
            }
            else
            {
                this.place = UTILS_HELPER.deepClone(new Place, this.basePlace);
            }

            this.imageData = this.place.photoPath;
        },
        submitClicked(){
            this.submitted = true;

            // Emit event
            if(this.place.isValid())
            {
                var input = new InputPlace(null, this.place, this.$refs.fileInput.files[0]);
                // TODO Replace by Place id
                if(this.basePlace && this.$route.params.id)
                {
                    input.id = this.$route.params.id;
                }

                this.loading = true;
                this.$emit('submit-requested', input);
            }
        },
        genericValidator(){
            var result = undefined; // This is the default, in case the user hasn't submitted yet

            // Validate error
            if(this.submitted && this.addError)
            {
                result = false;
            }

            return result;
        },
        nameValidator(){
            var result = this.genericValidator();

            if(this.submitted && result != false)
            {
                result = Boolean(this.place.name);
            }

            return result;
        },
    },
    watch:
    {
        basePlace: function(val)
        {
            this.resetPlace();
        },
        type: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        message: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        }
    }
}
</script>

<style>
.base-image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.placeholder {
  background: #F0F0F0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}

.placeholder:hover {
  background: #E0E0E0;
}

.file-input {
  display: none;
}

img
{
  width: 50%;
  height: 50%;
}

.base-image-input.is-invalid > span
{
  background-color: #e55353;
  color: white;
}
</style>